// src/app/pipes/payment-code.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paypointCode',
})
export class PaypointCodePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    // Remove "payment-" prefix if present
    let code = value.replace(/^paypoint-/, '');
    // Remove all dashes
    code = code.replace(/-/g, '');
    // Get the first 5 characters and convert to uppercase
    const shortCode = code.substring(0, 5).toUpperCase();
    return `#PP-${shortCode}`;
  }
}
